import { FILTER_TYPES } from 'components/FilterPod';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const filters = (getCredit) => [
  {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'cellphoneNumber',
    query: 'cellphoneNumber',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'نام کاربری',
    label: 'نام کاربری',
    keyName: 'userName',
    query: 'userName ',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'پست الکترونیک',
    label: 'پست الکترونیک',
    keyName: 'email',
    query: 'email',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
];

export default filters;
